<template>
    <div v-if="client">
      <dl v-if="type === 'list'">
        <div class="bg-white list-row">
          <dt class="list-row-dt">
            {{$t('generic.name')}}
          </dt>
          <dd class="list-row-dd">
            <div class="flex items-center">
              <base-avatar :src="client.image" :name="client.name" :circle="false" size="sm" alt="User avatar"/>
              <span class="ml-1">{{client.name || $t('generic.na')}}</span>
            </div>
          </dd>
        </div>
        <div class="bg-gray-50 list-row">
          <dt class="list-row-dt">
            {{$t('generic.address')}}
          </dt>
          <dd class="list-row-dd">
            <span v-if="clientAddress" v-html="clientAddress"></span>
            <span v-else>{{$t('generic.na')}}</span>
          </dd>
        </div>
      </dl>

      <div v-else class="flex items-center">
        <div class="flex-shrink-0">
          <img class="h-12 w-12 rounded-full" :src="client.image || $avatar.generate(client.name)" :alt="client.name">
        </div>
        <div class="ml-4">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            {{client.name}}
          </h3>
          <p v-if="clientAddress"
             v-html="clientAddress"
             class="text-sm leading-5 text-gray-500">
          </p>
        </div>
      </div>
    </div>
</template>
<script>
  export default {
    name: 'client-card',
    props: {
      client: {
        type: Object
      },
      showFooter: {
        type: Boolean,
        default: true
      },
      type: {
        type: String,
        default: 'card'
      }
    },
    computed: {
      clientAddress() {
        let addresses = this.client.addresses
        if (!addresses) {
          return ''
        }
        let primaryAddress = addresses.find(a => a.primary);
        if(!primaryAddress) {
          return '';
        }
        return ` ${primaryAddress.address_line_1}, <br/> ${primaryAddress.city}`
      }
    }
  }
</script>
